import { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import { get } from '../../../services/apiController';

const getQueryParams = ({ types }) => {
  const queryParams = {};
  if (types) {
    queryParams.types = types;
  }
  return queryParams;
};

export default function Branch({ onChange, types }) {
  const [branches, setBranches] = useState([]);

  const getBranches = async () => {
    const queryParams = getQueryParams({ types: types });
    const response = await get(`/v1/branches?` + new URLSearchParams(queryParams));
    setBranches(response.data);
  };

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  useEffect(() => {
    getBranches();
  }, []);

  return (
    <FloatingLabel controlId="floatingSelect" label="Location">
      <Form.Select onChange={handleChange}>
        <option value="">Select Location</option>
        {branches.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </Form.Select>
    </FloatingLabel>
  );
}
